import React from 'react';
import styled, { css } from 'styled-components';
import Icon from './Icon';

const getVariantStyles = (variant) => {
  switch (variant) {
    case 'secondary':
      return css`
        background-color: transparent;
        color: var(--ink);
        border: 1.5px solid var(--line-strong);

        &:hover {
          border-color: var(--ink);
        }
      `;
    case 'success':
      return css`
        background-color: var(--diff-add);
        color: var(--white);
        border: 1.5px solid var(--diff-add);

        &:hover {
          background-color: var(--diff-add-ink);
          border-color: var(--diff-add-ink);
        }
      `;
    case 'danger':
      return css`
        background-color: var(--diff-remove-bg);
        color: var(--diff-remove);
        border: 1.5px solid var(--diff-remove-bg);

        &:hover {
          border-color: var(--diff-remove);
        }
      `;
    case 'ghost':
      return css`
        background-color: transparent;
        color: var(--ink-soft);
        border: 1.5px solid transparent;

        &:hover {
          color: var(--ink);
          border-color: var(--line);
        }
      `;
    case 'primary':
    default:
      return css`
        background-color: var(--ink);
        color: var(--white);
        border: 1.5px solid var(--ink);

        &:hover {
          background-color: var(--accent-ink);
          border-color: var(--accent-ink);
        }
      `;
  }
};

const getSizeStyles = (size) => {
  switch (size) {
    case 'sm':
      return css`
        padding: 8px 16px;
        font-size: 12px;
      `;
    case 'lg':
      return css`
        padding: 14px 26px;
        font-size: 0.95rem;
      `;
    default:
      return css`
        padding: 12px 20px;
        font-size: 13px;
      `;
  }
};

const Button = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  border-radius: var(--radius-sm);
  font-weight: 600;
  cursor: pointer;
  transition: background-color var(--transition-fast), border-color var(--transition-fast), color var(--transition-fast);
  white-space: nowrap;

  ${props => getVariantStyles(props.$variant)}
  ${props => getSizeStyles(props.$size)}

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

const IconWrapper = styled.span`
  display: flex;
  align-items: center;
`;

const StyledButton = ({
  onClick,
  label,
  icon,
  variant = 'default',
  size = 'md',
  disabled = false,
  type = 'button',
}) => {
  return (
    <Button
      onClick={onClick}
      $variant={variant}
      $size={size}
      disabled={disabled}
      type={type}
    >
      {icon && <IconWrapper><Icon name={icon} size={16} /></IconWrapper>}
      {label}
    </Button>
  );
};

export default StyledButton;
